import cx from 'classnames'
import React, { useEffect } from 'react'

import { isHouseRelatedType } from '@js/common/utils'

import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import ActionCardTemplate from '@f/elements/ActionCardTemplate'
import FormWrapper from '@f/elements/FormWrapper'
import Icon from '@f/elements/Icon'

const HouseBuyerStage = props => {
  useEffect(() => {
    props.actions.update_wtValue({ value: 'house-buyer-stage' })
  }, [])

  const isConversionFunnel = Boolean(props.funnelVariant)

  const handleSelection = value => {
    const detail = {
      house_buyer_stage: value
    }

    _wt({
      category: 'form',
      action: 'submit',
      location: 'modal-house-buyer-stage',
      values: [
        {
          type: 'house_buyer_stage',
          value: value
        }
      ],
      ...props.data.trackingInfo
    })

    props.actions.handleUserDataChange({
      detail,
      forcePostRequest: isHouseRelatedType(props.requestType)
    })
    props.actions.move({})
  }

  const options = [
    {
      value: 'inspiration',
      label: 'Suche nach Inspiration',
      CardIcon: () => (
        <Icon
          icon='process-step-1-64px-fill'
          className={cx(
            'f-c-fi-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    },
    {
      value: 'information',
      label: 'Informiere mich zum Ablauf',
      CardIcon: () => (
        <Icon
          icon='process-step-2-64px-fill'
          className={cx(
            'f-c-fi-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    },
    {
      value: 'comparison',
      label: 'Bewerte potenzielle Anbieter',
      CardIcon: () => (
        <Icon
          icon='process-step-3-64px-fill'
          className={cx(
            'f-c-fi-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    },
    {
      value: 'offers',
      label: 'Vergleiche Preisangebote',
      CardIcon: () => (
        <Icon
          icon='process-step-4-64px-fill'
          className={cx(
            'f-c-fi-pri',
            isConversionFunnel ? 'f-icon-100' : 'f-icon-050'
          )}
        />
      )
    }
  ]

  return (
    <FormWrapper
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel'
      )}
      data-wtloc='modal-house-buyer-stage'>
      <div className='RequestWizard-top'>
        <div className='[ f-p-b-020 ] RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Wo befinden Sie sich gerade auf dem Weg zu Ihrem Traumhaus?
          </div>
        </div>

        <div className='RequestWizard-content'>
          <div className='[ f-overflow ]'>
            <div className='RequestWizard-options-wrapper'>
              {options.map(option => (
                <QuestionRadioButton
                  key={option.value}
                  wtData={{
                    location: 'modal-house-buyer-stage',
                    flow_information: props.data.trackingInfo.flow_information
                  }}
                  onClick={() => handleSelection(option.value)}>
                  <ActionCardTemplate
                    sizeActionCard={isConversionFunnel ? 'large' : undefined}
                    {...option}
                  />
                </QuestionRadioButton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  )
}

export default HouseBuyerStage
